import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Result } from 'antd';

// ============================================================================
// COMPONENTES E UI
// ============================================================================
import { Button } from 'components/ds';

// ============================================================================
// ESTILOS
// ============================================================================
import { Container, Title, SubTitle, ButtonStyle } from './NotFound.styles';

// ============================================================================
// COMPONENTE
// ============================================================================

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Result
        status="404"
        title={<Title>Página não encontrada</Title>}
        subTitle={
          <SubTitle>
            Desculpe, a página que você está procurando não existe ou foi removida.
          </SubTitle>
        }
        extra={
          <Button 
            type="highlight" 
            onClick={() => navigate(-1)}
            size="large"
            className="pwa-button padding-x-big"
            style={ButtonStyle}
          >
            Voltar
          </Button>
        }
      />
    </Container>
  );
};

export default NotFound;
